import React from "react";
import PageTemplate from "../components/PageTemplate";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { menuList } from "../utils/menu";

const Consulting = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTemplate title={t(menuList[4].title)} menuList={menuList[4].list} backgroundImage="/imgs/bg_digitaltwin" />
      <div className="consulting_wrap" style={{ maxWidth: "1920px", width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Outlet />
      </div>
    </>
  );
};

export default Consulting;
